import * as React from "react";
import Button from "@mui/material/Button"
import Link from "@mui/material/Link";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Title from "../Common/Title";

export default function Messages( { id_session, token } ) {
    const get_message = (id_message, id_session, time, message, author, feedback) => {
        return { id_message, id_session, time, message, author, feedback };
    }

    const [messages, set_messages] = React.useState([]);

    const update_messages = async () => {
        fetch(`${process.env.REACT_APP_API_URL}/session/messagelist`, 
            {
                method: "POST", 
                headers: {
					"Content-Type": "application/json",
					"Token": token
				}, 
                body: JSON.stringify({
                    id_session: id_session,
                    token: token
                })
            }
        )
        .then((response) => response.json())
        .then((data) => {
            const transformedData = data.map(([id_message, id_session, time, message, author, feedback]) => {
                // Function to format dates by removing milliseconds
                const formatDate = (dateString) => {
                if (!dateString) return null; // Return null if dateString is null
                const date = new Date(dateString);
                return `${date.toISOString().split(".")[0]}`; // Remove milliseconds and retain the "Z" timezone indicator
            };

                // Function to transform message newlines into arrays for React rendering
                const formatMessage = (message) => {
                    return message.split('\n').map((part, index) => (
                        <React.Fragment key={index}>
                        {part}
                        <br />
                        </React.Fragment>
                    ));
                };
            
                // Apply formatting to time
                const formattedTime = formatDate(time);

                // Apply formatting to message
                const formattedMessage = formatMessage(message);
                
                // Return the message object with formatted times
                return get_message(id_message, id_session, formattedTime, formattedMessage, author, feedback);
            });
            
            // Update the messages state with the transformed and formatted data
            set_messages(transformedData);
        }).catch((error) => console.error("Error fetching messages:", error));
    }

    React.useEffect(() => {
        update_messages();
    }, [id_session]);

    function preventDefault(event) {
        event.preventDefault();
    }

    return (
        <React.Fragment>
        <Title>Message Log (Session ID: { id_session })</Title>
        <Table size="small">
            <TableHead>
            <TableRow>
                <TableCell>Message ID</TableCell>
                <TableCell>Time</TableCell>
                <TableCell>Contents</TableCell>
                <TableCell>Author</TableCell>
                <TableCell>Feedback</TableCell>
            </TableRow>
            </TableHead>
            <TableBody>
            {messages.map((message) => (
                <TableRow key={message.id_message}> {/* Ensure each row has a unique key */}
                <TableCell>{message.id_message}</TableCell>
                <TableCell>{message.time}</TableCell>
                <TableCell>{message.message}</TableCell>
                <TableCell>{message.author}</TableCell>
                <TableCell>{message.feedback}</TableCell>
                </TableRow>
            ))}
            </TableBody>
        </Table>
        </React.Fragment>
    );
}